import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=059bba8b&scoped=true"
import script from "./CalendarEvents.vue?vue&type=script&lang=js"
export * from "./CalendarEvents.vue?vue&type=script&lang=js"
import style0 from "./CalendarEvents.vue?vue&type=style&index=0&id=059bba8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059bba8b",
  null
  
)

export default component.exports